import * as React from 'react';
import { getStringTable } from '../../utilities/localizationUtilities.dynamic';
import { OfficeNavButton } from './OfficeNavButton';
export async function getOfficeNavButtonWithStrings(locale) {
    const stringTable = await getStringTable(locale);
    return {
        default: (props)=>/*#__PURE__*/ React.createElement(OfficeNavButton, {
                title: stringTable.openInOffice,
                ...props
            })
    };
}
